/** Every `LabelStatus` member, in the exact order declared by the YAML enum. */
export const LABEL_STATUSES = ['processing', 'ready', 'failed', 'canceled'];
/** Every `LabelFailureReason` member, in the exact order declared by the YAML enum. */
export const LABEL_FAILURE_REASONS = [
    'PRICE_CHANGED',
    'PROVIDER_REJECTED',
    'AUTH_ERROR',
    'INVALID_ADDRESS',
    'INSUFFICIENT_BALANCE',
];
//# sourceMappingURL=label.js.map